import { render } from "./ProjectCards.vue?vue&type=template&id=42066a57&scoped=true"
import script from "./ProjectCards.vue?vue&type=script&lang=js"
export * from "./ProjectCards.vue?vue&type=script&lang=js"

import "./ProjectCards.vue?vue&type=style&index=0&id=42066a57&scoped=true&lang=scss"

import exportComponent from "/voc/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-42066a57"]])

export default __exports__